<h2 mat-dialog-title class="cdf-dialog__title">{{ 'title.data_field_editor' | translate | uppercase }}</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <mat-dialog-content class="cdf-dialog__content">
    <!-- Field type (only choosable on create; fixed afterwards) -->
    <label class="cdf-dialog__field" *ngIf="isNew">
      <span class="cdf-dialog__field-label">{{ 'label.field_type' | translate | uppercase }}</span>
      <select class="ts-selector" formControlName="type" data-cy="field-type">
        <option *ngFor="let t of types" [value]="t">{{ 'core.fieldType.' + t | translate }}</option>
      </select>
    </label>

    <div class="cdf-dialog__field" *ngIf="!isNew">
      <span class="cdf-dialog__field-label">{{ 'label.field_type' | translate | uppercase }}</span>
      <span class="cdf-dialog__readonly-value">{{ 'core.fieldType.' + selectedType | translate }}</span>
    </div>

    <!-- Shared display name + generated internal name hint -->
    <label class="cdf-dialog__field">
      <span class="cdf-dialog__field-label">{{ 'label.display_name' | translate | uppercase }}</span>
      <input class="ts-input" type="text" required formControlName="displayName" data-cy="field-display-name" />
      <span class="cdf-dialog__hint">{{ 'label.internal_field_name' | translate }}: <b>{{ internalName }}</b></span>
    </label>

    <!-- required / encrypted (every variant except label) -->
    <div class="cdf-dialog__checks" *ngIf="showsRequiredAndEncrypted(selectedType)">
      <mat-checkbox formControlName="required" data-cy="field-required">{{ 'check.required' | translate }}</mat-checkbox>
      <mat-checkbox formControlName="encrypted" data-cy="field-encrypted">{{ 'check.encrypted' | translate }}</mat-checkbox>
    </div>

    <!-- Number -->
    <ng-container *ngIf="selectedType === 'number'">
      <h4 class="cdf-dialog__section-title">{{ 'label.numeric_field_options' | translate }}</h4>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.decimals' | translate | uppercase }}</span>
        <input class="ts-input" type="number" formControlName="decimals" data-cy="field-decimals" />
      </label>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.min' | translate | uppercase }}</span>
        <input class="ts-input" type="number" formControlName="min" data-cy="field-min" />
      </label>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.max' | translate | uppercase }}</span>
        <input class="ts-input" type="number" formControlName="max" data-cy="field-max" />
      </label>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.units' | translate | uppercase }}</span>
        <input class="ts-input" type="text" formControlName="units" data-cy="field-units" />
      </label>
    </ng-container>

    <!-- Text -->
    <ng-container *ngIf="selectedType === 'textedit'">
      <mat-checkbox formControlName="multiline" data-cy="field-multiline">
        {{ 'case_data_field_editor.multiline' | translate }}
      </mat-checkbox>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.placeholder' | translate | uppercase }}</span>
        <input class="ts-input" type="text" formControlName="placeholder" data-cy="field-placeholder" />
      </label>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.max_lines' | translate | uppercase }}</span>
        <input class="ts-input" type="number" formControlName="maxLines" data-cy="field-max-lines" />
      </label>
      <label class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.max_length' | translate | uppercase }}</span>
        <input class="ts-input" type="number" formControlName="maxLength" data-cy="field-max-length" />
      </label>
    </ng-container>

    <!-- case_name placeholder -->
    <label class="cdf-dialog__field" *ngIf="selectedType === 'case_name'">
      <span class="cdf-dialog__field-label">{{ 'case_data_field_editor.placeholder' | translate | uppercase }}</span>
      <input class="ts-input" type="text" formControlName="placeholder" data-cy="field-placeholder" />
    </label>

    <!-- Options (selection / switcher) -->
    <ng-container *ngIf="needsOptions(selectedType)">
      <div class="cdf-dialog__field">
        <span class="cdf-dialog__field-label">{{ 'label.options' | translate | uppercase }}</span>
        <mat-form-field class="cdf-dialog__chips">
          <mat-chip-grid #optionsGrid data-cy="field-options">
            <mat-chip-row *ngFor="let option of form.controls.options.value" (removed)="removeOption(option)">
              {{ option }}
              <button matChipRemove type="button"><i class="ri-close-line"></i></button>
            </mat-chip-row>
            <input
              [placeholder]="'case_data_field_editor.options_hint' | translate"
              [matChipInputFor]="optionsGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addOption($event)"
            />
          </mat-chip-grid>
        </mat-form-field>
      </div>
      <mat-checkbox formControlName="multiple" data-cy="field-multiple">
        {{ 'case_data_field_editor.allow_multiple' | translate }}
      </mat-checkbox>
    </ng-container>

    <!-- Boolean default -->
    <mat-checkbox *ngIf="selectedType === 'boolean'" formControlName="default" data-cy="field-default">
      {{ 'case_data_field_editor.default_value' | translate }}
    </mat-checkbox>
  </mat-dialog-content>

  <mat-dialog-actions class="cdf-dialog__actions">
    <button
      type="button"
      class="btn btn-outline-primary cdf-dialog__action"
      (click)="cancel()"
      data-cy="field-cancel"
    >
      {{ 'button.cancel' | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary cdf-dialog__action"
      [disabled]="!canSave"
      data-cy="field-save"
    >
      {{ 'button.continue' | translate }}
    </button>
  </mat-dialog-actions>
</form>
